export const trimMultipleSpaces = (value: string) => {
  return value.replace(/\s{2,}/g, ' ')
}
